export default __webpack_public_path__ + "static/media/banner-3.3d76564c.jpg";